// extracted by mini-css-extract-plugin
export default {"backChevron":"LeftChevronButton_backChevron__zXuDR","dark":"LeftChevronButton_dark__Vm8TJ"};